"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadReadinessCheckerSLIObserver = void 0;
var _react = require("react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _commonWebAnalytics = require("../../client/web/commonWebAnalytics");
/**
 * Starts the "studio load readiness checker" SLI the moment the app navigates
 * to a join / readiness route. The matching page ends the SLI from its mount
 * effect via useLoadReadinessCheckerSLI(), so the measured interval is the
 * initial page load (route change -> first paint) and excludes the async
 * device readiness tests.
 *
 * Because this lives above the lazily-loaded route, the measurement also
 * captures the route chunk download. Render it once, inside the app router.
 * It renders nothing.
 *
 * @param {Object} props
 * @param {string|string[]} props.paths - Route path pattern(s) whose entry
 *   should start the SLI (e.g. the join route, plus the standalone readiness
 *   route where applicable).
 * @returns {null}
 */
var LoadReadinessCheckerSLIObserver = exports.LoadReadinessCheckerSLIObserver = function LoadReadinessCheckerSLIObserver(_ref) {
  var paths = _ref.paths;
  var _useLocation = (0, _reactRouterDom.useLocation)(),
    pathname = _useLocation.pathname;
  var startedForPathname = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var match = (0, _reactRouterDom.matchPath)(pathname, {
      path: paths,
      exact: true
    });
    // Only start on entry to a matching route, and only once per navigation.
    if (!match || startedForPathname.current === pathname) {
      return;
    }
    startedForPathname.current = pathname;
    (0, _commonWebAnalytics.startStudioLoadReadinessChecker)({
      pathName: match.path,
      url: pathname
    });
  }, [pathname, paths]);
  return null;
};
LoadReadinessCheckerSLIObserver.propTypes = {
  paths: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]).isRequired
};